export const pricingPlans = [
    {
        name: "Flexible Learning",
        price: "Starting at $1",
        period: "per session",
        description: "Pay-as-you-learn with flexible session options",
        features: {
            "15-minute Quick Sessions": true,
            "1-hour Standard Sessions": true,
            "15-hour Intensive Programs": true,
            "AI-Powered Tutoring": true,
            "Progress Tracking": true,
            "Session Recordings": true,
            "No Long-term Commitment": true
        },
        isPopular: true
    },
    {
        name: "Monthly Subscription",
        price: "$299",
        period: "per month",
        description: "Unlimited access to all learning features",
        features: {
            "Unlimited AI Tutoring": true,
            "All Learning Materials": true,
            "Advanced Analytics": true,
            "Priority Support": true,
            "Session Recordings": true,
            "Personalized Learning Paths": true,
            "Monthly Progress Reports": true
        },
        isPopular: false
    },
    {
        name: "Enterprise",
        price: "Custom Pricing",
        period: "contact us",
        description: "For organizations and institutions",
        features: {
            "Custom Learning Solutions": true,
            "Bulk Session Packages": true,
            "Dedicated Support": true,
            "Custom Analytics": true,
            "API Integration": true,
            "White-label Options": true,
            "Volume Discounts": true
        },
        isPopular: false
    }
]; 